import type { ReactNode } from 'react';

interface VehicleSubmitErrorAlertProps {
    title: string;
    children: ReactNode;
}

const VehicleSubmitErrorAlert = ({ title, children }: VehicleSubmitErrorAlertProps) => (
    <div className='display-flex justify-content-center margin-bottom-10'>
        <div
            className={`alert alert-danger display-grid width-350 rounded-md
                gap-10 grid-cols-2-max-content-1fr font-sans`}
            role='alert'
        >
            <div className='display-flex justify-content-start align-items-start'>
                <span className='text-color-danger text-size-h4 rioglyph rioglyph-info-sign' />
            </div>
            <div className='display-flex gap-10'>
                <div>
                    <strong className='text-size-16 font-weight-600'>{title}</strong>
                    <div className='margin-y-5 text-size-14'>{children}</div>
                </div>
            </div>
        </div>
    </div>
);

export default VehicleSubmitErrorAlert;
